export const CHOICES = {
  TYPES: {
    BUILDING: {
      TERTIARY: "TERTIARY",
      INDUSTRIAL: "INDUSTRIAL",
      RESIDENTIAL: "RESIDENTIAL",
      ARTISANAL_COMMERCIAL: "ARTISANAL_COMMERCIAL",
      SENSITIVE_ESTABLISHMENT: "SENSITIVE_ESTABLISHMENT",
    },
    COMPONENT: {
      BRULAGE_AREA: "BRULAGE_AREA",
      TANK: "TANK",
      TREATMENT_STRUCTURE: "TREATMENT_STRUCTURE",
      DRAINAGE: "DRAINAGE",
      GENERATOR_SET: "GENERATOR_SET",
      TRANSFORMER: "TRANSFORMER",
      BOILER: "BOILER",
      PAINT_BOOTH: "PAINT_BOOTH",
      METER_DISTRIBUTION_TRACK: "METER_DISTRIBUTION_TRACK",
      DISCHARGING: "DISCHARGING",
      MACHINE: "MACHINE",
      SOLVENTS_FOUNTAIN: "SOLVENTS_FOUNTAIN",
      WASHING_AREA: "WASHING_AREA",
      WASTE_AREA: "WASTE_AREA",
      BASIN: "BASIN",
      STORAGES: "STORAGES",
      POLLUTION_TRACES: "POLLUTION_TRACES",
      PIEZOMETER_WELL: "PIEZOMETER_WELL",
      PIEZOMETER_AIR: "PIEZOMETER_AIR",
      BACKFILL: "BACKFILL",
      SPECIFIC_INVESTIGATION: "SPECIFIC_INVESTIGATION",
    },
    BASIAS_BASOL_SIS_NEARBY_SITE_OTHER: {
      BASIAS: "BASIAS",
      BASOL: "BASOL",
      SIS: "SIS",
      NEARBY_SITE: "NEARBY_SITE",
      BASIAS_OTHER: "BASIAS_OTHER",
    },
  },
  NATURE: {
    PIEZOMETER_WELL: ["PIEZOMETER", "WELL"],
    PIEZOMETER_AIR: ["PIEZAIR", "AIR_UNDER_SLAB_SUBSLAB"],
  },
  CONTENT: [
    "FUEL_OIL",
    "GASOLINE",
    "DIESEL",
    "NRD",
    "NEW_OILS",
    "USED_OILS",
    "SOLVENTS",
    "MULTIPLE_FUELS",
    "UNDEFINED",
  ],
  AREA_POSITIONING: ["INDOOR", "COVERED_OUTDOOR", "UNCOVERED_OUTDOOR"],
  USAGE: {
    "COMPONENT BRULAGE_AREA": [],
    "COMPONENT TANK": [],
    "COMPONENT TREATMENT_STRUCTURE": [],
    "COMPONENT DRAINAGE": ["DRAINAGE_PIT"],
    "COMPONENT GENERATOR_SET": [],
    "COMPONENT TRANSFORMER": [],
    "COMPONENT BOILER": [],
    "COMPONENT PAINT_BOOTH": [],
    "COMPONENT METER_DISTRIBUTION_TRACK": [],
    "COMPONENT DISCHARGING": [],
    "COMPONENT MACHINE": [],
    "COMPONENT SOLVENTS_FOUNTAIN": [],
    "COMPONENT WASHING_AREA": [],
    "COMPONENT WASTE_AREA": [],
    "COMPONENT BASIN": [],
    "COMPONENT STORAGES": [],
    "COMPONENT POLLUTION_TRACES": [],
    "COMPONENT PIEZOMETER_WELL": [
      "MONITORING",
      "GEOTECHNICS",
      "DRILLING",
      "DRINKING_WATER",
      "WATERING_IRRIGATION",
      "INDUSTRIAL_WATER",
    ],
    "COMPONENT PIEZOMETER_AIR": ["MONITORING"],
    "COMPONENT SPECIFIC_INVESTIGATION": [],
    "BUILDING BACKFILL": [],
    "BUILDING TERTIARY": ["OFFICES"],
    "BUILDING INDUSTRIAL": ["GARAGE", "HANGAR", "WORKSHOP"],
    "BUILDING RESIDENTIAL": ["INDIVIDUAL_RESIDENCE", "COLLECTIVE_RESIDENCE"],
    "BUILDING ARTISANAL_COMMERCIAL": ["PRESSING", "TRADE"],
    "BUILDING SENSITIVE_ESTABLISHMENT": [
      "SCHOOL",
      "NURSERY",
      "COLLEGE",
      "HIGH_SCHOOL",
      "NURSING_HOME",
      "SENIOR_RESIDENCE",
      "HOSPITAL",
      "CLINIC",
    ],
    ZONE: [
      "OFFICES",
      "TECHNICAL_ROOM",
      "MECHANICAL_WORKSHOP",
      "MAINTENANCE_WORKSHOP",
      "TRADE",
      "HANGAR",
      "LOCKER_ROOMS",
    ],
    OUTDOOR_SPACE: [
      "WAYS",
      "COLLECTIVE_GREEN_SPACES",
      "PRIVATE_GARDENS",
      "STABILIZED_GROUND",
      "BARE_LAND",
    ],
  },
  TAGS_TYPES: ["SOURCE", "INCERTITUDE"],
  OCCUPATION_PRESENCE: ["REGULAR_PRESENCE", "OCCASIONAL_PRESENCE", "NO_PRESENCE"],
  TOOLS_TYPES: [
    "OIL_SEPARATOR",
    "DESANDING_UNIT",
    "SETTLER",
    "DEGREASER",
    "BIOLOGICAL_PRETREATMENT",
    "PHYSICO_CHEMICAL_PRETREATMENT",
  ],
  IMPACTED_ENVIRONMENT: ["SOIL", "SURFACE_WATER"],
  FUEL_ENERGY: ["FUEL_OIL", "GASOLINE", "DIESEL", "NRD", "MULTIPLE_FUELS", "GAS", "BIOMASS"],
  DIELECTRIC: ["CONFIRMED_PYRALENE", "SUSPECTED_PYRALENE", "DIELECTRIC_WITHOUT_PCB"],
  STORAGE_TYPES: ["PRODUCTS", "WASTE", "MATERIALS", "MISCELLANEOUS"],
  LOCATIONS: ["GROUND_FLOOR", "BASEMENT", "UPPER_FLOORS"],
  USED_FLUIDS: ["FUEL_OIL", "GASOLINE", "DIESEL", "OILS", "SOLVENTS"],
  STATUS: ["GOOD", "NEW", "BAD"],
  PACKAGING: ["SKIP", "CRATES", "DRUMS", "CANS", "BULK"],
  PRODUCT_TYPES: [
    "FUEL_OIL",
    "GASOLINE",
    "DIESEL",
    "NEW_OILS",
    "USED_OILS",
    "SOLVENTS",
    "ACIDS",
    "BASES",
    "PAINT",
    "COOLANT",
    "AD_BLUE",
  ],
  WASTES_TYPES: ["USED_OILS", "USED_FILTERS", "DRUMS", "SOLVENT_CANS", "METAL_WASTE"],
  HEATING_MODES: ["GAS", "ELECTRICITY", "FUEL_OIL", "WOOD", "HEAT_PUMP", "NO_HEATING"],
  PRESENT_PEOPLE: ["WORKERS", "ADULT_RESIDENTS", "CHILD_RESIDENTS", "SENIORS"],
  WATERPROOF_SURFACE: ["YES", "NO", "YES_BUT_IN_BAD_STATUS"],
  WATERPROOFING_LAYERS: ["WATERPROOFING_ASPHALT", "WATERPROOFING_CONCRETE_SLAB"],
  SOIL_TYPES: ["CONCRETE_SLAB", "TILES", "BARE_LAND"],
  SLAB_CONDITIONS: ["GOOD", "BAD"],
  INERTAGE_METHODS: ["WATER", "SAND", "CONCRETE_N"],
  MATERIALS: ["CONCRETE", "METALLIC", "TILED"],
  REJECTION: [
    "NATURAL_ENVIRONMENT",
    "MUNICIPAL_EP_NETWORK",
    "MUNICIPAL_EU_NETWORK",
    "SITE_EP_NETWORK",
    "SITE_EU_NETWORK",
  ],
  TRACER_COMPOUND: [
    "HCT",
    "HAP",
    "HV",
    "ETM",
    "BTEX",
    "COHV",
    "PCB",
    "BILAN_ISDI",
    "SOLVANTS_POLAIRES",
    "POC",
    "POP",
    "GLYCOLS",
    "DIOXINES_FURANES",
  ],
  POSITION: [
    "NORTH",
    "NORTH_EAST",
    "EAST",
    "SOUTH_EAST",
    "SOUTH",
    "SOUTH_WEST",
    "WEST",
    "NORTH_WEST",
  ],
  ASSUMED_HYDRAULIC_POSITIONING: ["UPSTREAM", "DOWNSTREAM", "LATERAL", "NOT_KNOWN"],
  RISK_JUSTIFICATION: ["DISTANCE", "DOWNSTREAM_HYDRAULIC", "NO_DISCHARGE"],
  ENVIRONMENTS_POTENTIALLY_IMPACTED: ["SOILS", "GROUNDWATERS", "SURFACE_WATERS", "SOILS_GAS"],
};

export const TYPOLOGIES = {
  BUILDING: "BUILDING",
  ZONE: "ZONE",
  COMPONENT: "COMPONENT",
  OUTDOOR_SPACE: "OUTDOOR_SPACE",
  SPREADING: "SPREADING",
  BASIAS_BASOL_SIS_NEARBY_SITE_OTHER: "BASIAS_BASOL_SIS_NEARBY_SITE_OTHER",
};

export const CONDITIONS = {
  SPECIFIC_INVESTIGATION: ["locationInsideBuilding", "locationInsideZone"],
  TANK: [
    "position",
    "content",
    "remoteUnloading",
    "doubleSkin",
    "diameter",
    "temporality",
    "usage",
    "isCompartment",
    "width",
    "volume",
    "length",
    "installationDate",
    "isPollutionTraces",
    "locationInsideBuilding",
    "locationInsideZone",
    "existenceOfAConstraint",
    "constraintAccuracy",
  ],
  TRANSFORMER: [
    "remplacementDate",
    "dielectricPresence",
    "underTension",
    "temporality",
    "installationDate",
    "waterproofSurface",
    "isPollutionTraces",
    "locationInsideBuilding",
    "locationInsideZone",
    "existenceOfAConstraint",
    "constraintAccuracy",
  ],
  POLLUTION_TRACES: [
    "impactedEnvironment",
    "description",
    "surface",
    "locationInsideBuilding",
    "locationInsideZone",
    "existenceOfAConstraint",
    "constraintAccuracy",
  ],
  STORAGES: [
    "storageType",
    "temporality",
    "areaPositioning",
    "installationDate",
    "waterproofSurface",
    "isPollutionTraces",
    "isRetention",
    "storageConditions",
    "wasteDisposalRecoveryConditions",
    "wastesType",
    "surface",
    "locationInsideBuilding",
    "locationInsideZone",
    "existenceOfAConstraint",
    "constraintAccuracy",
  ],
  GENERATOR_SET: [
    "retention",
    "fuelEnergy",
    "integratedTank",
    "installationDate",
    "temporality",
    "usage",
    "waterproofSurface",
    "isPollutionTraces",
    "locationInsideBuilding",
    "locationInsideZone",
    "existenceOfAConstraint",
    "constraintAccuracy",
  ],
  BOILER: [
    "retention",
    "fuelEnergy",
    "integratedTank",
    "installationDate",
    "temporality",
    "waterproofSurface",
    "isPollutionTraces",
    "locationInsideBuilding",
    "locationInsideZone",
    "existenceOfAConstraint",
    "constraintAccuracy",
  ],
  DISTRIBUTION_METER_TRACK: [
    "fuelEnergy",
    "temporality",
    "installationDate",
    "waterproofSurface",
    "isPollutionTraces",
    "existenceOfAConstraint",
    "constraintAccuracy",
  ],
  DISCHARGING: [
    "fuelEnergy",
    "temporality",
    "installationDate",
    "waterproofSurface",
    "locationInsideBuilding",
    "locationInsideZone",
    "isPollutionTraces",
    "existenceOfAConstraint",
    "constraintAccuracy",
  ],
  BACKFILL: [
    "backfillType",
    "isPollutionTraces",
    "locationInsideBuilding",
    "locationInsideZone",
    "existenceOfAConstraint",
    "constraintAccuracy",
  ],
  DRAINAGE: [
    "depth",
    "materials",
    "installationDate",
    "temporality",
    "usage",
    "width",
    "length",
    "isPollutionTraces",
    "locationInsideBuilding",
    "locationInsideZone",
    "existenceOfAConstraint",
    "constraintAccuracy",
  ],
  TREATMENT_STRUCTURE: [
    "depth",
    "rejection",
    "installationDate",
    "temporality",
    "width",
    "length",
    "waterproofSurface",
    "isPollutionTraces",
    "collectedEffluent",
    "locationInsideBuilding",
    "locationInsideZone",
    "existenceOfAConstraint",
    "constraintAccuracy",
  ],
  BRULAGE_AREA: [
    "temporality",
    "description",
    "areaPositioning",
    "burnedProducts",
    "surface",
    "waterproofSurface",
    "isPollutionTraces",
    "details",
    "remarks",
    "photo",
    "tracerCompound",
    "analyticalStandard",
    "quantificationLimit",
    "source",
    "justification",
    "locationInsideBuilding",
    "locationInsideZone",
    "existenceOfAConstraint",
    "constraintAccuracy",
  ],
  PAINT_BOOTH: [
    "depth",
    "rejectionLocation",
    "temporality",
    "installationDate",
    "waterproofSurface",
    "isPollutionTraces",
    "locationInsideBuilding",
    "locationInsideZone",
    "existenceOfAConstraint",
    "constraintAccuracy",
  ],
  METER_DISTRIBUTION_TRACK: [
    "temporality",
    "fuelEnergy",
    "waterproofSurface",
    "installationDate",
    "isPollutionTraces",
    "locationInsideBuilding",
    "locationInsideZone",
    "existenceOfAConstraint",
    "constraintAccuracy",
  ],
  BASIN: [
    "depth",
    "isWaterproof",
    "sphcConnected",
    "details",
    "temporality",
    "width",
    "length",
    "volume",
    "collectedEffluent",
    "presenceOfSludge",
    "locationInsideBuilding",
    "locationInsideZone",
    "existenceOfAConstraint",
    "constraintAccuracy",
  ],
  MACHINE: [
    "usedFluids",
    "temporality",
    "usage",
    "installationDate",
    "waterproofSurface",
    "isPollutionTraces",
    "locationInsideBuilding",
    "locationInsideZone",
    "existenceOfAConstraint",
    "constraintAccuracy",
  ],
  SOLVENTS_FOUNTAIN: [
    "usedSolvant",
    "temporality",
    "installationDate",
    "waterproofSurface",
    "isPollutionTraces",
    "locationInsideBuilding",
    "locationInsideZone",
    "existenceOfAConstraint",
    "constraintAccuracy",
  ],
  WASTE_AREA: [
    "packaging",
    "position",
    "temporality",
    "areaPositioning",
    "installationDate",
    "waterproofSurface",
    "isPollutionTraces",
    "wastesType",
    "wasteDisposalRecoveryConditions",
    "isRetention",
    "locationInsideBuilding",
    "locationInsideZone",
    "existenceOfAConstraint",
    "constraintAccuracy",
  ],
  PIEZOMETER_WELL: [
    "nature",
    "details",
    "usage",
    "installationDate",
    "structureDepth",
    "waterDepth",
    "diameter",
    "locationInsideBuilding",
    "locationInsideZone",
    "existenceOfAConstraint",
    "constraintAccuracy",
  ],
  PIEZOMETER_AIR: [
    "nature",
    "details",
    "usage",
    "structureDepth",
    "installationDate",
    "diameter",
    "locationInsideBuilding",
    "locationInsideZone",
    "existenceOfAConstraint",
    "constraintAccuracy",
  ],
  WASHING_AREA: [
    "areaPositioning",
    "sphcConnected",
    "isPollutionTraces",
    "temporality",
    "width",
    "length",
    "installationDate",
    "waterproofSurface",
    "locationInsideBuilding",
    "locationInsideZone",
    "existenceOfAConstraint",
    "constraintAccuracy",
  ],
  BASIAS: [
    "label",
    "referenceBasiasBasolSis",
    "companyName",
    "activityDescription",
    "startDate",
    "inOperation",
    "endDate",
    "siteItself",
    "address",
    "distanceToSite",
    "position",
    "assumedHydraulicPositioning",
    "riskOfContaminationTransferToTheSite",
    "riskJustification",
    "remarks",
    "tracerCompound",
    "analyticalStandard",
    "quantificationLimit",
    "isSourceTakenIntoAccount",
    "justification",
    "environmentsPotentiallyImpacted",
  ],
  BASOL: [
    "label",
    "referenceBasiasBasolSis",
    "companyName",
    "activityDescription",
    "startDate",
    "inOperation",
    "endDate",
    "siteItself",
    "address",
    "distanceToSite",
    "position",
    "assumedHydraulicPositioning",
    "riskOfContaminationTransferToTheSite",
    "riskJustification",
    "remarks",
    "tracerCompound",
    "analyticalStandard",
    "quantificationLimit",
    "isSourceTakenIntoAccount",
    "justification",
    "environmentsPotentiallyImpacted",
  ],
  SIS: [
    "label",
    "referenceBasiasBasolSis",
    "companyName",
    "activityDescription",
    "startDate",
    "inOperation",
    "endDate",
    "siteItself",
    "address",
    "distanceToSite",
    "position",
    "assumedHydraulicPositioning",
    "riskOfContaminationTransferToTheSite",
    "riskJustification",
    "remarks",
    "tracerCompound",
    "analyticalStandard",
    "quantificationLimit",
    "isSourceTakenIntoAccount",
    "justification",
    "environmentsPotentiallyImpacted",
  ],
  NEARBY_SITE: [
    "label",
    "referenceBasiasBasolSis",
    "companyName",
    "activityDescription",
    "startDate",
    "inOperation",
    "endDate",
    "riskOfContaminationTransferToTheSite",
    "riskJustification",
    "remarks",
    "tracerCompound",
    "analyticalStandard",
    "quantificationLimit",
    "isSourceTakenIntoAccount",
    "justification",
    "environmentsPotentiallyImpacted",
    "distanceToSite",
    "assumedHydraulicPositioning",
    "position",
  ],
  BASIAS_OTHER: [
    "label",
    "referenceBasiasBasolSis",
    "companyName",
    "activityDescription",
    "startDate",
    "inOperation",
    "endDate",
    "siteItself",
    "address",
    "distanceToSite",
    "position",
    "assumedHydraulicPositioning",
    "riskOfContaminationTransferToTheSite",
    "riskJustification",
    "remarks",
    "tracerCompound",
    "analyticalStandard",
    "quantificationLimit",
    "isSourceTakenIntoAccount",
    "justification",
    "environmentsPotentiallyImpacted",
  ],
};
